export enum CurrencyEnum {
  BOB = "BOB",
  USD = "USD",
}

export enum CollectionEnum {
  USERS = "users",
  ORDERS = "orders",
  COMMERCES = "commerces",
}

export enum PaymentStatusEnum {
  PAID = "paid",
  ERROR = "error",
  PENDING = "pending",
  CANCELLED = "cancelled",
}

export type ApiResponse = {
  code: number;
  message: string;
  data?: any;
  error?: any;
};
